import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { LanguageToggle } from "./components/LanguageToggle";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { DisclaimerPage, PrivacyPage, TermsPage } from "./pages/LegalPages";
import EmployerPortal from "./pages/EmployerPortal";
import WorkerPortal from "./pages/WorkerPortal";
import IdCardPage from "./pages/IdCardPage";
import PayoutSlipPage from "./pages/PayoutSlipPage";
import BookCleaning from "./pages/BookCleaning";
import { ADMIN_LOGIN_PATH, ADMIN_PATH } from "./constants/adminRoutes";

const AdminGuard = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-[#0B1120]"><Loader2 className="h-6 w-6 animate-spin text-orange-500" /></div>;
  }
  return user ? children : <Navigate to={ADMIN_LOGIN_PATH} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path={ADMIN_LOGIN_PATH} element={<AdminLogin />} />
          <Route path={ADMIN_PATH} element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/employer" element={<EmployerPortal />} />
          <Route path="/worker" element={<WorkerPortal />} />
          <Route path="/id/:token" element={<IdCardPage />} />
          <Route path="/slip/:token" element={<PayoutSlipPage />} />
          <Route path="/book" element={<BookCleaning />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <LanguageToggle />
        <Toaster position="bottom-right" offset={88} mobileOffset={{ bottom: 88 }} theme="light" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
